import { createFileRoute } from "@tanstack/react-router";
import { DiffViewer } from "@/pages/3d/visualization/DiffViewer";

export const Route = createFileRoute("/demo/3d/visualization/diff-viewer")({
  component: DiffViewer,
});
